import { LatLngLiteral } from "leaflet";
import { Marker, useMapEvents } from "react-leaflet";

import { MarkerIcon, parseLatLng, serializePoint } from "../../../lib/location";
import Map from "../../map/Map";
import { RendererProps } from "../Input";

const ZOOM_DEFAULT = 8;
const ZOOM_DETAIL = 14;

const ClickHandler = ({
  onClick,
}: {
  onClick: (latLng: LatLngLiteral) => void;
}) => {
  useMapEvents({
    click: (e) => {
      onClick(e.latlng);
    },
  });

  return null;
};

const LocationInput = ({ name, onChange, value }: RendererProps) => {
  const latLng = parseLatLng(value);

  const handleChange = (point: LatLngLiteral) =>
    onChange?.({ target: { name, value: serializePoint(point) } });

  return (
    <>
      <Map
        center={latLng ? { lat: latLng.lat, lng: latLng.lng } : undefined}
        height="20em"
        zoom={latLng ? ZOOM_DETAIL : ZOOM_DEFAULT}
      >
        {latLng && (
          <Marker icon={MarkerIcon} position={[latLng.lat, latLng.lng]} />
        )}
        <ClickHandler onClick={(newLatLng) => handleChange(newLatLng)} />
      </Map>
    </>
  );
};

export default LocationInput;
